export default {
  subheadline: 'Te ustawienia określają, jak Qmulus przedstawia Twoją firmę, np. w nagłówku raportów PDF.',
};
